import React, { useState } from 'react';
import { OFFICIAL_LINKS } from '../data/servicesData';
import { MessageCircle, X, Send, ArrowRight } from 'lucide-react';

export const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [userMsg, setUserMsg] = useState('');

  const sendWhatsApp = (customMsg) => {
    const textToSend = customMsg || userMsg || 'Hello Fi Pay Bills Team, I would like to inquire about your Pay-In, Payout and Fintech solutions.';
    const encoded = encodeURIComponent(textToSend);
    window.open(`https://wa.me/91${OFFICIAL_LINKS.phone}?text=${encoded}`, '_blank');
  };

  const serviceQuickLinks = [
    { label: 'Subpaisa & Payment Gateway', msg: 'Hi Fi Pay Bills, I want to integrate Subpaisa and Pay-In Gateway for my business.' },
    { label: 'Instant Payouts & All Banks (T+0/T+1)', msg: 'Hi Fi Pay Bills, I need Instant Payouts (T+0/T+1) across all Indian banks.' },
    { label: 'Validation Kit (PAN, Aadhaar, Bank Details)', msg: 'Hi Fi Pay Bills, I need the complete Validation Kit API (PAN, Aadhaar, Bank Penny Drop, UPI).' },
    { label: 'Apply Razorpay Onboarding', msg: 'Hi Fi Pay Bills, I want to onboard and Apply for Razorpay payment gateway.' },
    { label: 'Apply Cashfree Onboarding', msg: 'Hi Fi Pay Bills, I want to onboard and Apply for Cashfree gateway & payouts.' },
    { label: 'Loan & EMI Calculator (Multi-Lender)', msg: 'Hi Fi Pay Bills, I want to apply for a Business / Personal Loan through your multi-lender platform.' },
    { label: 'Insurance Portal (Health, Life, Motor)', msg: 'Hi Fi Pay Bills, I want to inquire about policies and POSP partner commissions on your Insurance portal.' },
    { label: 'Smart Android POS & 4G Soundboxes', msg: 'Hi Fi Pay Bills, I need Android Smart POS machines and 4G voice soundboxes for my shop.' },
    { label: 'Fintech APIs (AEPS, MATM, DMT, CMS)', msg: 'Hi Fi Pay Bills, I need your complete 14+ Fintech Banking API suite for my portal.' },
    { label: 'Become a Partner (Refer & Earn)', msg: 'Hi Fi Pay Bills, I want to register as a Refer & Earn Partner.' },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end">
      {/* Expanded Quick Message Bubble */}
      {isOpen && (
        <div className="mb-3 w-88 max-w-[calc(100vw-2rem)] bg-white rounded-3xl shadow-2xl border-2 border-emerald-500/30 overflow-hidden fi-pop flex flex-col max-h-[82vh]">
          {/* Header */}
          <div className="bg-gradient-to-r from-emerald-700 to-teal-800 text-white p-4 flex items-center justify-between shrink-0 shadow-xs">
            <div className="flex items-center gap-3">
              <div className="relative">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center font-black text-white border border-white/20">
                  <MessageCircle className="w-5 h-5 text-white" />
                </div>
                <span className="absolute bottom-0 right-0 w-3 h-3 bg-emerald-400 border-2 border-emerald-700 rounded-full"></span>
              </div>
              <div>
                <h4 className="font-black text-sm">Fi Pay Bills WhatsApp Desk</h4>
                <p className="text-[11px] text-emerald-100 flex items-center gap-1">
                  <span>+91 {OFFICIAL_LINKS.phone}</span>
                  <span>&bull;</span>
                  <span>Active Now</span>
                </p>
              </div>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white/80 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Body */}
          <div className="p-4 bg-slate-50 space-y-3 text-xs overflow-y-auto flex-1">
            <div className="bg-white p-3.5 rounded-2xl rounded-tl-none border border-slate-200 shadow-2xs text-slate-800 space-y-1">
              <p className="font-bold text-slate-900">
                Namaste! Welcome to Fi Pay Bills Hyderabad Desk.
              </p>
              <p className="text-slate-600 text-[11px] leading-relaxed">
                Connect directly with our solutions team on WhatsApp for instant onboarding, API keys, loans, or portal activation.
              </p>
              <span className="text-[10px] text-emerald-700 font-bold block pt-1 text-right">
                ● Live Support · Fast 5m Response
              </span>
            </div>

            {/* Service Quick Inquiry Buttons */}
            <div className="space-y-1.5 pt-1">
              <span className="text-[10px] font-black uppercase tracking-wider text-slate-400 block px-1">
                Select a Service to Inquire on WhatsApp:
              </span>
              <div className="space-y-1 max-h-52 overflow-y-auto pr-1">
                {serviceQuickLinks.map((s, idx) => (
                  <button
                    key={idx}
                    onClick={() => sendWhatsApp(s.msg)}
                    className="w-full text-left p-2.5 rounded-xl bg-white hover:bg-emerald-50 border border-slate-200 hover:border-emerald-300 text-slate-800 text-[11px] font-semibold transition-all flex items-center justify-between group cursor-pointer shadow-2xs"
                  >
                    <span className="truncate pr-2">{s.label}</span>
                    <ArrowRight className="w-3.5 h-3.5 text-slate-400 group-hover:text-emerald-600 shrink-0" />
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Footer Input */}
          <div className="p-3 bg-white border-t border-slate-200 flex items-center gap-2 shrink-0">
            <input
              type="text"
              value={userMsg}
              onChange={(e) => setUserMsg(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && sendWhatsApp()}
              placeholder="Ask anything on WhatsApp..."
              className="flex-1 px-3 py-2 text-xs rounded-xl border border-slate-300 focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50"
            />
            <button
              onClick={() => sendWhatsApp()}
              className="p-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl transition-colors shrink-0 shadow-xs cursor-pointer"
              title="Send to WhatsApp"
            >
              <Send className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      {/* Main WhatsApp Float Trigger */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="group relative flex items-center gap-2.5 bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-3.5 rounded-full shadow-xl shadow-emerald-600/30 transition-all duration-200 hover:scale-105 cursor-pointer"
        aria-label="Chat on WhatsApp (+91 8247814987)"
      >
        <MessageCircle className="w-6 h-6 shrink-0" />
        <span className="text-xs font-black tracking-wide pr-1 hidden sm:inline-block">
          WhatsApp Support (+91 8247814987)
        </span>
        <span className="text-xs font-black tracking-wide pr-1 sm:hidden">
          WhatsApp
        </span>
        <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-emerald-300 rounded-full border-2 border-white animate-pulse"></span>
      </button>
    </div>
  );
};
